import { createFileRoute, redirect } from '@tanstack/react-router';

// RFC-098: Redirect to new compliance tasks
export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/evidence/work-queue')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/compliance/tasks',
      params: { workspaceId: params.workspaceId },
    });
  },
});
